const initState = {
  contests: [],
  contestAthletes: [],
  lastVisible: null,
  hasMore: true,
  contestOrganizer: null,
  contestDetails: {
    data: [],
    lastVisible: null,
    hasMore: true,
  },
};

const contestReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_CONTESTS_SUCCESS":
      return {
        ...state,
        contests: action.payload.isLoadingMore
          ? [...state.contests, ...action.payload.data]
          : action.payload.data,
        lastVisible: action.payload.lastVisible,
        hasMore: action.payload.hasMore,
      };
    case "FETCH_CONTEST_ATHLETES":
      return {
        ...state,
        contestAthletes: action.payload,
      };
    case "PARTICIPATE_CONTEST_SUCCESS":
      return {
        ...state,
        contests: state.contests?.map((contest) =>
          contest.id === action.payload
            ? { ...contest, schoolStatus: "pending" }
            : contest
        ),
      };
    case "FETCH_CONTESTS_ORGANIZER_SUCCESS":
      return {
        ...state,
        contestOrganizer: action.payload,
      };
    case "FETCH_CONTESTS_DETAILS_SUCCESS":
      return {
        ...state,
        contestDetails: {
          data: action.payload.isLoadingMore
            ? [...state.contestDetails.data, ...action.payload.data]
            : action.payload.data,
          lastVisible: action.payload.lastVisible,
          hasMore: action.payload.hasMore,
        },
      };
    default:
      return {
        ...state,
      };
  }
};
export default contestReducer;
